export type CommonLocaleOption = {
    code: string;
    label: string;
};

export const COMMON_LOCALES: CommonLocaleOption[] = [
    { code: 'ar', label: 'العربية' },
    { code: 'bg', label: 'Български' },
    { code: 'zh', label: '中文' },
    { code: 'hr', label: 'Hrvatski' },
    { code: 'cs', label: 'Čeština' },
    { code: 'da', label: 'Dansk' },
    { code: 'nl', label: 'Nederlands' },
    { code: 'en', label: 'English' },
    { code: 'et', label: 'Eesti' },
    { code: 'fi', label: 'Suomi' },
    { code: 'fr', label: 'Français' },
    { code: 'de', label: 'Deutsch' },
    { code: 'el', label: 'Ελληνικά' },
    { code: 'he', label: 'עברית' },
    { code: 'hi', label: 'हिन्दी' },
    { code: 'hu', label: 'Magyar' },
    { code: 'id', label: 'Bahasa Indonesia' },
    { code: 'it', label: 'Italiano' },
    { code: 'ja', label: '日本語' },
    { code: 'ko', label: '한국어' },
    { code: 'lv', label: 'Latviešu' },
    { code: 'lt', label: 'Lietuvių' },
    { code: 'ms', label: 'Bahasa Melayu' },
    { code: 'no', label: 'Norsk' },
    { code: 'pl', label: 'Polski' },
    { code: 'pt', label: 'Português' },
    { code: 'ro', label: 'Română' },
    { code: 'ru', label: 'Русский' },
    { code: 'sk', label: 'Slovenčina' },
    { code: 'sl', label: 'Slovenščina' },
    { code: 'es', label: 'Español' },
    { code: 'sv', label: 'Svenska' },
    { code: 'th', label: 'ไทย' },
    { code: 'tr', label: 'Türkçe' },
    { code: 'uk', label: 'Українська' },
    { code: 'vi', label: 'Tiếng Việt' },
];

export const COMMON_LOCALE_CODES = new Set(COMMON_LOCALES.map((locale) => locale.code));

export const isCommonLocale = (locale: string | null | undefined): locale is string => (
    typeof locale === 'string' && COMMON_LOCALE_CODES.has(locale)
);